import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import DemosEvolvedSection from './components/DemosEvolvedSection';
import ForSection from './components/ForSection';
import AnalyticsSection from './components/AnalyticsSection';
import OurBetStory from './components/OurBetStory';
import WhySection from './components/WhySection';
import TwitterExcitementSection from './components/TwitterExcitementSection';
import LastPage from './components/LastPage';
import Footer from './components/Footer';

/* Full-width grey line that extends to screen edges */
const FullWidthDivider = () => (
  <div
    style={{
      width: '100%',
      height: '1px',
      background: '#c0c5ce',
    }}
  />
);

const Home = () => {
  return (
    <div style={{ background: '#fff', minHeight: '100vh', position: 'relative' }}>
      {/* Fixed Navbar */}
      <Navbar />

      {/* Spacer for fixed navbar */}
      <div style={{ height: '76px' }} />

      {/* Main content wrapper with constant grey edge lines */}
      <div
        style={{
          width: '100%',
          maxWidth: 'min(var(--frame-max), calc(100vw - (2 * var(--page-gutter))))',
          margin: '0 auto',
          position: 'relative',
          overflow: 'visible',
        }}
      >
        {/* Left grey edge line */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            width: '1px',
            background: '#c0c5ce',
            zIndex: 10,
            pointerEvents: 'none',
          }}
        />
        {/* Right grey edge line */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            width: '1px',
            background: '#c0c5ce',
            zIndex: 10,
            pointerEvents: 'none',
          }}
        />

        {/* 
          Section order:
          1. Hero (wispy sky video)
          2. Demos just evolved (scroll animation + 4 cards)
          3. For anyone who needs to show a product (timeline)
          4. Real analytics (carousel)
          5. Our bet + Our story
          6. Why we built demoboy? (3 cards)
          7. Twitter excitement (horizontal scroll)
          8. Last page (get early access + 3D video)
        */}
        <FullWidthDivider />
        <HeroSection />
        <FullWidthDivider />
        <DemosEvolvedSection />
        <FullWidthDivider />
        <ForSection />
        <FullWidthDivider />
        <AnalyticsSection />
        <FullWidthDivider />
        <OurBetStory />
        <FullWidthDivider />
        <WhySection />
        <FullWidthDivider />
        <TwitterExcitementSection />
        <FullWidthDivider />
        <LastPage />
        <FullWidthDivider />
      </div>

      <Footer />
    </div>
  );
};

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
